<!--
-- @brief 获取单个字段的html文本显示
-- @author zl
-- @date 2024年04月12日11:29:39
-->
<template>
  <div class="comp-xl-text-value">
    <template v-if="modulesItem?.fieldValue">
      <template v-if="fieldType == 6">
        <template v-if="modulesItem?.fieldValue?.length">
          <ly-avatar :record="modulesItem?.fieldValue" :size="22"></ly-avatar>
        </template>
        <template v-else> - </template>
      </template>
      <template v-else-if="fieldType == 7"> {{ tools.getNumberShow(modulesItem?.fieldValue, modulesItem?.fieldExt) }}{{ tools.isJSON(modulesItem?.fieldExt) && JSON.parse(modulesItem?.fieldExt)?.numberUnit ? JSON.parse(modulesItem?.fieldExt)?.numberUnit : '' }} </template>
      <template v-else-if="fieldType == 9">
        {{ tools.isJSON(modulesItem?.fieldValue) && modulesItem?.fieldValue != '{}' ? Object.values(JSON.parse(modulesItem?.fieldValue))?.join('/') : '-' }}
      </template>
      <template v-else-if="fieldType == 12">
        <template v-if="modulesItem?.fieldValue?.label">
          <jw-tooltip :content="modulesItem?.fieldValue?.label" position="left" :style="{ zIndex: getFieldItem?.zIndex + 2 }">
            <span class="text-ellipsis">{{ modulesItem?.fieldValue?.label }}</span>
          </jw-tooltip>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="fieldType == 16">
        {{ tools.getPriceShow(modulesItem?.fieldValue, modulesItem?.fieldExt) }}
      </template>
      <template v-else-if="fieldType == 22">
        <template v-if="modulesItem?.fieldValue?.length">
          <field-depart-show :params="{ fieldValue: modulesItem?.fieldValue }"></field-depart-show>
        </template>
        <template v-else> - </template>
      </template>
      <template v-else-if="fieldType == 23"> {{ tools.getPercentage(modulesItem?.fieldValue, modulesItem?.fieldExt) }}% </template>
      <template v-else-if="fieldType == 24">
        <template v-if="modulesItem?.fieldExt && tools.isJSON(modulesItem?.fieldExt)">
          <template v-if="JSON.parse(modulesItem?.fieldExt)?.type == 6 || JSON.parse(modulesItem?.fieldExt)?.type == 16">
            {{ tools.getPriceShow(modulesItem?.fieldValue, modulesItem?.fieldExt) }}
          </template>
          <template v-else-if="JSON.parse(modulesItem?.fieldExt)?.type == 23"> {{ tools.getPercentage(modulesItem?.fieldValue, modulesItem?.fieldExt) }}% </template>
          <template v-else-if="JSON.parse(modulesItem?.fieldExt)?.type == 5 || JSON.parse(modulesItem?.fieldExt)?.type == 7">
            {{ !isNaN(parseFloat(modulesItem?.fieldValue)) ? tools.getNumberShow(modulesItem?.fieldValue, modulesItem?.fieldExt) : '-' }}
          </template>
          <template v-else>
            <template v-if="modulesItem?.fieldValue">
              <jw-tooltip :content="modulesItem?.fieldValue" position="left" :style="{ zIndex: getFieldItem?.zIndex + 2 }">
                <span class="text-ellipsis">{{ modulesItem?.fieldValue }}</span>
              </jw-tooltip>
            </template>
            <template v-else>-</template>
          </template>
        </template>
        <template v-else>
          <template v-if="modulesItem?.fieldValue">
            <jw-tooltip :content="modulesItem?.fieldValue" position="left" :style="{ zIndex: getFieldItem?.zIndex + 2 }">
              <span class="text-ellipsis">{{ modulesItem?.fieldValue }}</span>
            </jw-tooltip>
          </template>
          <template v-else>-</template>
        </template>
      </template>
      <template v-else-if="fieldType == 25">
        <template v-if="Array.isArray(modulesItem?.fieldValue) && modulesItem?.fieldValue?.length > 0">
          <jw-tooltip :content="modulesItem?.fieldValue?.map((v) => v?.label)?.join(',')" position="left" :style="{ zIndex: getFieldItem?.zIndex + 2 }">
            <span class="text-ellipsis">{{ modulesItem?.fieldValue?.map((v) => v?.label)?.join(',') }}</span>
          </jw-tooltip>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else-if="fieldType == 26">
        <template v-if="modulesItem?.fieldValue">
          <ly-rich-text class="tv-rich" :fieldValue="modulesItem?.fieldValue" />
        </template>
        <template v-else>-</template>
      </template>
      <template v-else>
        <jw-tooltip :content="modulesItem?.fieldValue" position="left" :style="{ zIndex: getFieldItem?.zIndex + 2 }">
          <span class="text-ellipsis">{{ modulesItem?.fieldValue }}</span>
        </jw-tooltip>
      </template>
    </template>
    <template v-else>-</template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { tools } from '@/utils/tools.js';
import LyRichText from '@/components/layout/ly-rich-text/ly-rich-text.vue'; // 列表页富文本内容展示组件
import FieldDepartShow from '@/components/fh-set-fields/components/field-show/depart/depart.vue';
const props = defineProps({
  record: {
    type: Object,
    default: () => {
      return {};
    }
  },
  getFieldItem: {
    type: Object,
    default: () => {
      return {};
    }
  }
});
const fieldType = computed(() => {
  let ft = parseInt(props.record?.fieldType || props.record?.setting?.fieldType);
  if (ft === 21) {
    ft = parseInt(props.record?.business?.fieldType);
  }
  return ft;
});

const modulesItem = JSON.parse(JSON.stringify(props.record));
// 过滤 人员
if (modulesItem.fieldType == 6) {
  if (modulesItem.fieldValue?.length) {
    modulesItem.fieldValue = modulesItem.fieldValue?.filter((item) => item?.userId && item?.userName);
  }
}
// 过滤 部门
if (modulesItem.fieldType == 22) {
  if (modulesItem.fieldValue?.length) {
    modulesItem.fieldValue = modulesItem.fieldValue?.filter((item) => item?.id && item?.name);
  }
}
</script>
<style scoped lang="less">
@import './xl-text-value.less';
</style>
